<template>
  <v-tooltip v-if="visible" :disabled="!tooltip" top>
    <template v-slot:activator="{ on, attrs }">
      <span v-bind="attrs" v-on="on" class="construct-visual-text" :class="textClasses" :style="textStyle">{{ displayedValue }}</span>
    </template>
    <span class="construct-visual-text-tooltip">{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
import displayMixin from './mixin'

export default {
  name: 'ConstructVisualDisplayText',
  mixins: [displayMixin],
  computed: {
    value() { return this.resolveValue(this.item.value, this.item.source) },
    visible() { return !this.item.hideempty || ![null, undefined, ''].includes(this.value) },
    tooltip() {
      const value = this.resolveTemplate(this.item.tooltip)
      return value === null || value === undefined ? '' : String(value)
    },
    limitedValue() {
      const value = this.value === null || this.value === undefined ? '' : String(this.value)
      const limit = Math.floor(Number(this.item.limitCaracter))
      if (!Number.isFinite(limit) || limit <= 0) return value
      const characters = typeof Intl !== 'undefined' && Intl.Segmenter
        ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(value), entry => entry.segment)
        : Array.from(value)
      return characters.length > limit ? characters.slice(0, limit).join('') + '…' : value
    },
    displayedValue() {
      return this.formatAffixedValue(
        this.limitedValue,
        this.resolveTemplate(this.item.prefix),
        this.resolveTemplate(this.item.suffix),
      )
    },
    textClasses() {
      return [
        this.item.size || 'body-2',
        { 'font-weight-bold': this.item.bold, 'font-italic': this.item.italic },
      ]
    },
    textStyle() {
      return {
        color: this.resolveValue(this.item.color, this.item.colorSource) || undefined,
      }
    },
  },
}
</script>

<style scoped>
.construct-visual-text-tooltip { white-space: pre-wrap; }
</style>
